import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AccountingpolicyService } from './accountingpolicy.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-accountingpolicies',
  templateUrl: './accountingpolicies.component.html',
  styleUrls: ['./accountingpolicies.component.scss']
})
export class AccountingpoliciesComponent implements OnInit {
  policyform: FormGroup;
  APPeriodId: any; isJump: any;
  NormalRoutng: boolean;
  showBubbledata: any; disableDefaultButton: boolean
  Text: string = 'The financial statements are prepared in sterling which is the functional currency of the company.';
  defaulttext: string = 'The financial statements have been prepared on the going concern basis and under the historical cost convention as modified by the revaluation of land and buildings and certain financial instruments measured at fair value in accordance with the accounting policies.'
  constructor(private formbuilder: FormBuilder, private accountingpolicy: AccountingpolicyService, public commonService: CommonService, private router: Router, public sidenav: SideNavService) {
  }
  ngOnInit(): void {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.getpolicy(this.APPeriodId);
    this.isJump = localStorage.getItem('isJump')
    this.createaccountingpolicy();
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true);
        this.getlastyearpolicy()
      }
    })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})

    if (localStorage.getItem("SubmitStatus") == "true") {
      this.policyform.disable()
      this.disableDefaultButton = true
    }
    this.clearfield();
  }

  createaccountingpolicy() {
    this.policyform = this.formbuilder.group({
      APPeriodId: new FormControl(),
      AccountingPoliciesId: new FormControl(),
      BasisOfPreparation: new FormControl(this.defaulttext),
      PresentationCurrency: new FormControl(this.Text),
      AdditionalInformation: new FormControl(),
      CreatedBy: new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.policyform.reset()
      }
    })
  }

  Insertpolicy() {
    debugger
    if (this.validations()) {
      this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
      this.policyform.controls['APPeriodId'].setValue(this.APPeriodId)
      this.policyform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
      const formdata = this.policyform.getRawValue();
      this.accountingpolicy.insertaccountpolicy(formdata).subscribe((data) => {
        this.policyform.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Accounting policies", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.router.navigate(['/notes'])
        else if (nextPage == 'accountingpolicies') {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.router.navigate([nextPage]);
        }
        else {
          this.router.navigate([nextPage]);
        }
      })
    }
    else {
      this.NormalRoutng = false
      return false
    }

  }
  getpolicy(APPeriodId) {
    debugger

    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.accountingpolicy.Getaccountpolicy(this.APPeriodId).subscribe((data: any) => {
      this.policyform.patchValue(data);
      this.commonService.getNotesData();
      if (this.policyform.controls["BasisOfPreparation"].value == "" || this.policyform.controls["BasisOfPreparation"].value == null) {
        this.policyform.controls["BasisOfPreparation"].setValue(this.defaulttext);
      }
      if (this.policyform.controls["PresentationCurrency"].value == "" || this.policyform.controls["PresentationCurrency"].value == null) {
        this.policyform.controls["PresentationCurrency"].setValue(this.Text);
      }
    })
  }
  getlastyearpolicy() {
    this.accountingpolicy.GetaccountpolicyLy(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }
  getDefaultStatement(control) {
    if (control == "BasisOfPreparation")
      this.policyform.controls["BasisOfPreparation"].setValue(this.defaulttext)
    else if (control == "PresentationCurrency")
      this.policyform.controls["PresentationCurrency"].setValue(this.Text);
  }

  back() {
    debugger
    this.policyform.markAsPristine();
    localStorage.setItem("Backbutton", "true");
    var backpage;
    backpage = this.commonService.getBackSelection("Accounting policies", this.commonService.NotesList)
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else if (backpage == 'accountingpolicies')
      this.router.navigate(['/notes']);
    else {
      backpage = this.commonService.getBackSelection("Accounting policies", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }


  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.policyform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:bold'>You have unsaved data.</span><br><span>Do you want to save your changes before leaving? </span>",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.Insertpolicy()) {
            return true;
          }
          else if (!this.NormalRoutng)
            return false
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

  validations() {
    if (this.policyform.controls['BasisOfPreparation'].value == "" || this.policyform.controls['BasisOfPreparation'].value == null) {
      Swal.fire("Andica Accounts Production", "Basis of Preparation cannot be left blank.", "warning")
      return false
    } else if (this.policyform.controls['PresentationCurrency'].value == "" || this.policyform.controls['PresentationCurrency'].value == null) {
      Swal.fire("Andica Accounts Production", "Presentation currency cannot be left blank.", "warning")
      return false
    }
    return true
  }
}
